export default function () {
	return {
		// date: this.$persist('01/01/1990'),
		windowWidth: window.innerWidth,
		cart: {
			item_count: 0,
			attributes: {},
			items: [],
			total_price: 0,
		},

		scrollPosition: 0,
		totalDiscount: 0,
		cartDrawerDiscountText: '',
		url: window.location.href,
		code: '',
		show_discount_banner: this.$persist(true).using(sessionStorage),
		worker_url: 'https://order-counter.square-pond-8e19.workers.dev/',
		show_trustbadge: this.$persist(true).using(sessionStorage),

		get freeProductID() {
			return this.$root.dataset.freeId;
		},

		get discounts() {
			if (!this.cart.discount_codes) return [];
			if (this.cart.discount_codes.length === 0) return [];
			return this.cart.discount_codes.filter((item) => item.applicable);
		},

		async getCart() {
			const url = window.routes.cart + '.js';
			const response = await fetch(url);
			if (response.status !== 200) return;
			const cart = await response.json();

			this.cart = cart;
			// this.updateFreeProductAtCart();
		},

		updateCustomProperties() {
			document.documentElement.style.setProperty(
				'--announcement-height',
				(document.querySelector('#announcement-bar')?.offsetHeight || '0') + 'px',
			);
			document.documentElement.style.setProperty(
				'--header-height',
				(document.querySelector('#header')?.offsetHeight || '0') + 'px',
			);
			document.documentElement.style.setProperty('--window-width', this.windowWidth + 'px');
		},

		resize() {
			this.windowWidth = window.innerWidth;
			this.updateCustomProperties();
		},

		removePreloader() {
			if (!this.$refs.body.classList.contains('preloader')) return;
			if (window.page_type === 'product') {
				setTimeout(() => {
					this.$refs.body.classList.remove('preloader');
				}, 550);
			} else {
				setTimeout(() => {
					this.$refs.body.classList.remove('preloader');
				}, 200);
			}
		},
		getDiscountCoode() {
			if (this.code === '') {
				setTimeout(() => {
					let cookies = document.cookie.split(';');
					for (let i = 0; i < cookies.length; i++) {
						let cookie = cookies[i].split('=');
						if (cookie[0].trim() === 'discount_code' || cookie[0].trim() === 'docapp-auto-coupon') {
							this.code = decodeURIComponent(cookie[1]);
						}
					}
				}, 100);
			}
		},

		checkDiscount() {
			const discount_banner = document.querySelector('.js-discount');
			const countdown_banner = document.querySelector('.count-down');

			if (this.code) {
				if (this.url.includes('expired')) {
					const current_date = new Date().getTime();
					const date_from_url = new Date(this.url.split('?expired=')[1]);
					const time = date_from_url.getTime();
					const new_url = this.url.split('?expired=')[0];
					window.history.replaceState({}, '', new_url);
					if (current_date > time) {
						if (discount_banner) {
							discount_banner.classList.remove('visible');
						}
						if (countdown_banner) {
							countdown_banner.classList.remove('hidden');
						}
					} else {
						if (this.show_discount_banner === true) {
							if (discount_banner) {
								discount_banner.classList.add('visible');
							}
							if (countdown_banner) {
								countdown_banner.classList.add('hidden');
							}
						}
					}
				} else {
					if (this.show_discount_banner === true) {
						if (discount_banner) {
							discount_banner.classList.add('visible');
						}
						if (countdown_banner) {
							countdown_banner.classList.add('hidden');
						}
					}
				}
			} else {
				if (discount_banner) {
					discount_banner.classList.remove('visible');
				}
			}
			setTimeout(() => {
				if (discount_banner) {
					discount_banner.classList.remove('visible');
				}
				if (countdown_banner) {
					countdown_banner.classList.remove('hidden');
				}
				this.show_discount_banner = false;
			}, 10000);
		},

		hideBanner() {
			const discount_banner = document.querySelector('.js-discount');
			discount_banner.classList.remove('visible');
			this.show_discount_banner = false;
		},

		setDate() {
			if (this.date === '') {
				this.date = new Date().toLocaleDateString();
			} else return;
		},

		async getOrderCounterData() {
			let new_date = new Date().toLocaleDateString();
			if (this.date !== new_date) {
				this.date = new_date;
				const response = await fetch(this.worker_url);
				if (response.status !== 200) return;
				console.log('day passed');
			} else {
				console.log('day not passed');
			}
		},

		// ------ Custom code for adding free Gift product -----------------------------------------------------

		// updateFreeProductAtCart() {
		// 	const cartItemsIds = this.cart.items.map((item) => item.variant_id);
		// 	const cartItemsSkus = this.cart.items.map((item) => item.sku);
		// 	const notAllowedSkus = [
		// 		'P226',
		// 		'gift',
		// 		'K158',
		// 		'P304_P305',
		// 		'P321',
		// 		'K347',
		// 		'K348',
		// 		'K361',
		// 		'K406',
		// 	];
		// 	const cartPrice = this.cart.total_price;

		// 	const isCartItemForGift = cartItemsSkus.filter((sku) => {
		// 		const condition1 = !notAllowedSkus.includes(sku);
		// 		const condition2 = !sku.includes('P') || cartPrice > 4900;

		// 		if (condition1 && condition2) return sku;
		// 	}).length;
		// 	const isCartIncludesGift = cartItemsIds.includes(+this.freeProductID);

		// 	console.log('cartItemsIds', cartItemsIds);
		// 	console.log('this.freeProductID', +this.freeProductID);
		// 	console.log('isCartItemForGift', isCartItemForGift);
		// 	console.log('isCartIncludesGift', isCartIncludesGift);

		// 	if (isCartItemForGift && !isCartIncludesGift) {
		// 		this.addFreeProduct();
		// 		console.log('free product added');
		// 	} else if (!isCartItemForGift && isCartIncludesGift) {
		// 		this.deleteFreeProduct();
		// 		console.log('free product deleted');
		// 	}
		// },

		// async addFreeProduct() {
		// 	// if (window.sessionStorage.getItem("addedFree")) return;

		// 	// window.sessionStorage.setItem('addedFree', true)

		// 	if (this.freeProductID) {
		// 		const productData = {
		// 			id: this.freeProductID,
		// 			quantity: 1,
		// 			sections: 'cart-main,header',
		// 		};

		// 		const response = await fetch(window.routes.cartAdd + '.js', {
		// 			method: 'POST',
		// 			credentials: 'same-origin',
		// 			headers: {
		// 				'Content-Type': 'application/json',
		// 				'X-Requested-With': 'XMLHttpRequest',
		// 			},
		// 			body: JSON.stringify(productData),
		// 		});
		// 		const data = await response.json();

		// 		console.log('data', data);

		// 		if (response.ok) {
		// 			const destinationCartPopup = document.getElementById('cart-popup');
		// 			const sourceCartPopup = new DOMParser()
		// 				.parseFromString(data.sections['header'], 'text/html')
		// 				.getElementById('cart-popup');

		// 			if (destinationCartPopup && sourceCartPopup) {
		// 				destinationCartPopup.innerHTML = sourceCartPopup.innerHTML;
		// 			}

		// 			this.$dispatch('cart-update');
		// 		}
		// 	}
		// },

		// deleteFreeProduct() {
		// 	let formData = {
		// 		updates: {
		// 			[this.freeProductID]: 0,
		// 		},
		// 		sections: 'cart-main,header',
		// 	};
		// 	fetch(window.Shopify.routes.root + 'cart/update.js', {
		// 		method: 'POST',
		// 		headers: {
		// 			'Content-Type': 'application/json',
		// 		},
		// 		body: JSON.stringify(formData),
		// 	})
		// 		.then((response) => {
		// 			if (response.ok) {
		// 				this.$dispatch('cart-update');
		// 			}
		// 			return response.json();
		// 		})
		// 		.then((data) => {
		// 			let destination = document.getElementById('cart-main');
		// 			let source = new DOMParser()
		// 				.parseFromString(data.sections['cart-main'], 'text/html')
		// 				.getElementById('cart-main');
		// 			const destinationCartPopup = document.getElementById('cart-popup');
		// 			const sourceCartPopup = new DOMParser()
		// 				.parseFromString(data.sections['header'], 'text/html')
		// 				.getElementById('cart-popup');

		// 			if (destination && source) {
		// 				destination.innerHTML = source.innerHTML;
		// 			}
		// 			if (destinationCartPopup && sourceCartPopup) {
		// 				destinationCartPopup.innerHTML = sourceCartPopup.innerHTML;
		// 			}
		// 		})
		// 		.catch((error) => {
		// 			console.error('Error:', error);
		// 		});
		// },

		cookieFix() {
			const custom_links = document.querySelectorAll('.footer__menu--sublink.consent');
			custom_links.forEach((link) => {
				link.addEventListener('click', (e) => {
					const cookieButton = document.querySelector('.iubenda-tp-btn');
					cookieButton.click();
					e.preventDefault();
				});
			});
		},

		showTrustBadge() {
			if (!this.show_trustbadge) {
				document.body.classList.add('no-trust-badge');
			} else {
				const x = setInterval(() => {
					const badge = document.querySelector('[data-testid="minimized-trustbadge-floating"]');
					if (badge) {
						this.show_trustbadge = false;
						clearInterval(x);
					}
				}, 200);
			}
		},

		init() {
			this.getCart();
			this.updateCustomProperties();
			this.removePreloader();
			this.getDiscountCoode();
			this.cookieFix();
			// this.showTrustBadge();
			// this.setDate();
			// this.getOrderCounterData();

			setTimeout(() => {
				this.updateCustomProperties();
			}, 600);

			this.$watch('cart', () => {
				window.cart = this.cart;
			});

			this.$watch('code', () => {
				this.checkDiscount();
			});

			document.body.addEventListener('docapp-discount-applied', (e) => {
				if (e.cart) {
					this.totalDiscount = Math.round(e.cart.total_discount) / 100;
					if (this.totalDiscount > 0) {
						this.totalDiscount = this.totalDiscount.toString().replace('.', ',');

						this.cartDrawerDiscountText = ` '${e.discounts[0].title}' (-${e.discounts[0].percentageOfSubtotal}%)`;
					}
				}
			});
		},
	};
}
